import React, { Component } from 'react';
import * as PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Config from 'configuration';

import TwitterLogin from '@failbetter/react-twitter-auth';
import FacebookLogin from 'react-facebook-login';

import * as SettingsActionCreators from 'actions/settings';
import EmailLinkDialog from './EmailLinkDialog';
import EmailUpdateDialog from './EmailUpdateDialog';

import Dialog from '../../Dialog';


class AuthMethods extends Component {
  /**
   * Unlink social account
   * @param  {String} account
   * @return {undefined}
   */
  unLinkAccount = (account) => {
    const { dispatch } = this.props;
    dispatch(SettingsActionCreators.unlinkSocialAccount(account));
  }


  /**
   * Twitter Success
   * @param  {Object} res
   * @return {undefined}
   */
  twitterSuccess = (res) => {
    const { dispatch } = this.props;
    res.json().then((body) => {
      dispatch(SettingsActionCreators.linkSocialAccountSuccess(body, 'twitter'));
    });
  }


  /**
   * Twitter failed
   * @param  {Object} res
   * @return {Undefined}
   */
  twitterFailed = (res) => {
    res.json().then((body) => {
      console.error('twitter fail', body);
    });
  }


  /**
   * Facebook Response
   * @param  {Object} res
   * @return {undefined}
   */
  responseFacebook = (res) => {
    const { dispatch } = this.props;
    dispatch(SettingsActionCreators.linkFacebook(res));
  }

  /**
   * Toggle Email Link Dialog
   * @return {undefined}
   */
  toggleEmailLinkDialog = () => {
    const { dispatch } = this.props;
    dispatch(SettingsActionCreators.toggleEmailLinkDialog());
  }


  /**
   * toggle Email Update Dialog
   * @return {undefined}
   */
  toggleEmailUpdateDialog = () => {
    const { dispatch } = this.props;
    dispatch(SettingsActionCreators.toggleEmailUpdateDialog());
  }

  toggleNotificationDialog = () => {
    const { dispatch } = this.props;
    dispatch(SettingsActionCreators.toggleNotificationDialog());
  }

  renderEmailAuth = () => {
    const { data: { emailAuth, emailAddress } } = this.props;
    if (emailAuth) {
      return (
        <li>
          <i className="fa fa-envelope" />
          {' '}
          <button type="button" className="button--link" onClick={this.toggleEmailUpdateDialog}>{emailAddress}</button>
        </li>
      );
    }

    return (
      <li>
        <i className="fa fa-envelope-square" />
        <button type="button" className="button--link" onClick={this.toggleEmailLinkDialog}>
          Link your Email account
        </button>
      </li>
    );
  }

  renderFacebookAuth = () => {
    const { data: { facebookAuth } } = this.props;
    if (facebookAuth) {
      return (
        <li>
          <i className="fa fa-facebook-square" />
          {' '}
          <em>
            <button type="button" className="button--link" onClick={() => this.unLinkAccount('facebook')}>
              Unlink Facebook from this account
            </button>
          </em>
        </li>
      );
    }
    return (
      <li>
        <i className="fa fa-facebook-square" />
        <FacebookLogin
          tag="a"
          appId={Config.facebookAppId}
          cssClass="facebook-connect"
          textButton="&nbsp;Link Facebook to this account"
          autoLoad={false}
          fields="name,email,picture"
          callback={this.responseFacebook}
        />
      </li>
    );
  }

  renderTwitterAuth = () => {
    const { data: { twitterAuth } } = this.props;
    if (twitterAuth) {
      return (
        <li>
          <i className="fa fa-twitter-square" />
          {' '}
          <em>
            <button type="button" className="button--link" onClick={() => this.unLinkAccount('twitter')}>
              Unlink Twitter from this account
            </button>
          </em>
        </li>
      );
    }
    return (
      <li>
        <i className="fa fa-twitter-square" />
        <TwitterLogin
          tag="a"
          text="Link Twitter to this account"
          loginUrl={`${Config.apiUrl}twitter/linkaccount`}
          onFailure={this.twitterFailed}
          onSuccess={this.twitterSuccess}
          requestTokenUrl={`${Config.apiUrl}twitter/requesttoken`}
          credentials="include"
        />
      </li>
    );
  }


  /**
   * Render
   * @return {JSX}
   */
  render() {
    const {
      isEmailLinkDialogVisible,
      isEmailUpdateDialogVisible,
      isNotificationDialogOpen,
      notificationMessage,
    } = this.props;

    return (
      <div>
        <h2 className="heading heading--2">Authentication methods</h2>
        <ul className="list-icons">
          {this.renderEmailAuth()}
          {this.renderFacebookAuth()}
          {this.renderTwitterAuth()}
        </ul>

        <Dialog isOpen={isEmailLinkDialogVisible} onRequestClose={this.toggleEmailLinkDialog}>
          <EmailLinkDialog closeDialog={this.toggleEmailLinkDialog} />
        </Dialog>

        <Dialog isOpen={isEmailUpdateDialogVisible} onRequestClose={this.toggleEmailUpdateDialog}>
          <EmailUpdateDialog closeDialog={this.toggleEmailUpdateDialog} />
        </Dialog>

        <Dialog isOpen={isNotificationDialogOpen} onRequestClose={this.toggleNotificationDialog}>
          {notificationMessage}
        </Dialog>

      </div>
    );
  }
}

AuthMethods.propTypes = {
  data: PropTypes.shape({
    emailAuth: PropTypes.bool,
    facebookAuth: PropTypes.bool,
    twitterAuth: PropTypes.bool,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  isEmailLinkDialogVisible: PropTypes.bool.isRequired,
  isEmailUpdateDialogVisible: PropTypes.bool.isRequired,
  isNotificationDialogOpen: PropTypes.bool.isRequired,
  notificationMessage: PropTypes.string,
};

AuthMethods.defaultProps = {
  notificationMessage: undefined,
};

const mapStateToProps = state => (
  {
    data: state.settings.data,
    isEmailLinkDialogVisible: state.settings.isEmailLinkDialogVisible,
    isEmailUpdateDialogVisible: state.settings.isEmailUpdateDialogVisible,
    isNotificationDialogOpen: state.settings.isNotificationDialogOpen,
    notificationMessage: state.settings.notificationMessage,
  }
);

export default withRouter(connect(mapStateToProps)(AuthMethods));
